import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import fileDownload from "js-file-download";
import { BASE_API_URL } from "../../../utils/constants";

const baseURL = `${BASE_API_URL}/delivery_leadership`;

export const THSlice = createSlice({
  name: "deliveryLeadership",
  initialState: {
    error: false,
    TrackAdminUsers: [],
    nominationDataTH: [],
    courseMasterData: [],
    responseMessage: "",
    masterResponseMessage: "",
    abacusResponseMessage: "",
    monthWIseTrainingList: [],
    nominatedCourseListTH: [],
    nominatedUserListTH: [],
    nominatedUserListTHTemp: [],
    nominatedUserListOriginalData: [],
    bypassApprover: "No",
    bypassAbacus: "No",
    isUploaded: false,
    scheduledCount: 0,
    waitlistCount: 0,
    waitingForBatch: 0,
    discardedCount: 0,
    rejectedCount: 0,
    failedCount: 0,
    nominatedCount: 0,
    filter: 1,
    initialCheckboxStates: [],
    isLoaded: false,
    isDataSentSuccess: false,
    isDataSentFailure: false,
    count: [],
    currentMonth: "",
    currentMonthIndex: "",



    /////Nominations Section////


  trainingData: [],
  nominationData: [],
  enterpriseID: "",
  uploadedCourseList: [],
  myNominationData: [],
  },
  reducers: {
    setNominationDataTH: (state, { payload }) => {
      if (payload.status == 4) {
        state.nominatedUserListTH.map((val, i) => {
          payload.id.map((item, i) => {
            if (val.id == item) {
              val.status = payload.status;
              val.scheduledDate = payload.scheduledDate;
            }
          });
        });
      } else if (payload.status == 5) {
        state.nominatedUserListTH.map((val, i) => {
          payload.id.map((item, i) => {
            if (val.id == item) {
              val.status = payload.status;
            }
          });
        });
      }
      state.nominatedUserListTHTemp = state.nominatedUserListTH;

      if (payload.status == 4) {
        let filetedlist = state.nominatedUserListTH.filter(
          (item) => item.status == payload.filter
        );
        filetedlist.map((val, i) => {
          val.sno = i + 1;
        });
        state.nominatedUserListTH = filetedlist;
      } else {
        let filetedlist = state.nominatedUserListTH.filter(
          (item) => item.status == payload.filter
        );
        filetedlist.map((val, i) => {
          val.sno = i + 1;
        });
        state.nominatedUserListTH = filetedlist;
      }
    },
    setCourseMasterData: (state, { payload }) => {
      state.error = false;
      state.courseMasterData = payload;
    },
    setResponse: (state, { payload }) => {
      state.responseMessage = payload;
      state.isUploaded = true;
    },
    setMasterResponse: (state, { payload }) => {
      state.masterResponseMessage = payload;
      state.isUploaded = true;
    },
    setAbacusResponse: (state, { payload }) => {
      state.abacusResponseMessage = payload;
      state.isUploaded = true;
    },
    setLoaded: (state, { payload }) => {
      state.isLoaded = true;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = false;
    },
    setDataSuccess: (state) => {
      state.isLoaded = false;
      state.isDataSentSuccess = true;
      state.isDataSentFailure = false;
    },
    setDataFailure: (state, payload) => {
      state.isLoaded = false;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = true;
    },
    setMonthWiseTrainingList: (state, { payload }) => {
      state.monthWIseTrainingList = payload;
    },
    setNominatedCourseListTH: (state, { payload }) => {
      state.nominatedCourseListTH = payload;
    },
    setNominatedUserListTH: (state, { payload }) => {
      state.nominatedUserListTHTemp = payload;
      state.nominatedUserListOriginalData = payload;
      let filetedlist = payload.filter((item) => item.status == 2);
      filetedlist.map((val, i) => {
        val.sno = i + 1;
      });
      state.nominatedUserListTH = filetedlist;
      state.initialCheckboxStates = filetedlist.map((item) => ({
        [item.id]: false,
      }));
    },

    setNominatedCount: (state, { payload }) => {
      state.nominatedCount = payload[0].nominationCount;
    },
    setCount: (state, { payload }) => {
      state.discardedCount = 0;
      state.scheduledCount = 0;
      state.waitlistCount = 0;
      state.rejectedCount = 0;
      state.waitingForBatch = 0;
      state.failedCount = 0;
      state.nominatedCount = payload.reduce((acc, val) => acc + Number(val.count), 0);
      payload.map((val, i) => {
        if (val.status == "5") {
          state.discardedCount = val.count;
        }else if (val.status == "4") {
          state.waitlistCount = val.count;
        } else if (val.status == "3") {
          state.rejectedCount = val.count;
        } else if (val.status == "2") {
          state.scheduledCount = val.count;
        } else if (val.status == "1") {
          state.waitingForBatch = val.count;
        } else if (val.status == "0") {
          state.failedCount = val.count;
        } 
      });

      //  payload.result1.map((val, i) => {
      //   if (val.prevStatus == "2") {
      //    state.approvedCount += val.prev_count;
      //   }
      //  });
      //  payload.result2.map((val, i) => {
      //   if (val.status == "4") {
      //    state.scheduledCount = val.count;
      //   }
      //  });
    },
    setFilteredListTH: (state, { payload }) => {
      state.nominatedUserListTH = payload;
    },
    setBypassApprover: (state, { payload }) => {
      state.bypassApprover = payload;
    },
    setBypassAbacus: (state, { payload }) => {
      state.bypassAbacus = payload;
    },
    setAlert: (state) => {
      state.isUploaded = false;
    },

    setError: (state) => {
      state.error = true;
    },
    //// Sessions Section////

    setCurrentMonth: (state, { payload }) => {
       state.currentMonth = payload;
      },
      setCurrentMonthIndex: (state, { payload }) => {
       state.currentMonthIndex = payload;
      },




        //// Nomination Section////

        setTrainingData: (state, { payload }) => {
   state.error = false;
   state.trainingData = payload;
  },
  setNominationData: (state, { payload }) => {
   state.error = false;
   state.nominationData = payload;
  },
  setEnterpriseID: (state, { payload }) => {
   state.enterpriseID = payload.name;
  },
  setUploadedCourseList: (state, { payload }) => {
   state.uploadedCourseList = payload;
  },
  setMyNominationData: (state, { payload }) => {
   state.myNominationData = payload;
  },
  // User Maintenance //

  setTrackAdminUsers: (state, { payload }) => {
        state.error = false;
        state.TrackAdminUsers = payload;
      },
  },
});

// Action creators are generated for each case reducer function
export const {
  setError,
  setNominationDataTH,
  setCourseMasterData,
  setResponse,
  setMasterResponse,
  setAbacusResponse,
  setMonthWiseTrainingList,
  setNominatedCourseListTH,
  setNominatedUserListTH,
  setFilteredListTH,
  setAlert,
  setLoaded,
  setDataSuccess,
  setDataFailure,
  setUpdateCount,
  setBypassApprover,
  setBypassAbacus,
  setNominatedCount,
  setCount,
  setCurrentMonthIndex,
  //// Nominations ///

   setTrainingData,
   setNominationData,
   setUpdatedStatus,
   setEnterpriseID,
   setUploadedCourseList,
   setMyNominationData,
   setTrackAdminUsers
} = THSlice.actions;

export default THSlice.reducer;

export function updateTHStatus(
  courseCode,
  sessionCode,
  ids,
  statusReason,
  filter,
  originalFilter
) {
  return async (dispatch) => {
    dispatch(setLoaded());
    try {
      const res = await Axios.post(
        `${baseURL}/updateTHStatus`,
        { sessionCode, ids, statusReason, filter },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(setDataSuccess());
      // dispatch(setNominationDataTH({ id, status, scheduledDate, filter }));
      // dispatch(getCount(courseCode, startDate));
      dispatch(getAllNominationDataTH(courseCode, sessionCode, originalFilter));
      return res.data;
    } catch (err) {
      dispatch(setDataFailure());
      dispatch(setError(err));
      throw err;
    }
  };
}

export function getCourseMasterData(trackId) {
  return (dispatch) => {
    Axios.get(`${baseURL}/courses`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        res.data.map((val, i) => {
          val.sno = i + 1;
        });
        dispatch(setCourseMasterData(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
export function saveNewCourse(
  course_code,
  course_name,
  duration,
  audience_level,
  program_owner
) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/courses/save`,
      {
        course_code,
        course_name,
        duration,
        audience_level,
        program_owner,
      },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setDataSuccess());
        return dispatch(getCourseMasterData());
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function saveEditSME(courseCode, smeName) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/courses/saveedit`,
      { courseCode, smeName },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(getCourseMasterData());
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}
export function uploadTHFile(file, month, year, track) {
  return async (dispatch) => {
    dispatch(setLoaded());
    return Axios.post(`${baseURL}/sessions/bulkUpload`, file, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      params: {
        month,
        year,
        track,
      },
    })
      .then(async (res) => {
        await dispatch(setDataSuccess());
        await dispatch(setResponse("file Uploaded Successfully"));
        await dispatch(getTrainingListMonthWise(month, year))
      })
      .catch((err) => {
        dispatch(
          setResponse(err.response.data.message || "Sorry!!! Failed to upload")
        );
        dispatch(setDataFailure());
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
export function NominationListDelete(uniqueSessionID, month, year) {
  return (dispatch) => {
    dispatch(setLoaded());
    Axios.post(
      `${baseURL}/deletenomination`,
      { uniqueSessionID },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then(() => {
        dispatch(getTrainingListMonthWise(month, year));
        dispatch(setDataSuccess());
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
}
export function uploadMasterData(formData) {
  return (dispatch) => {
    dispatch(setLoaded());
    return Axios.post(`${baseURL}/courses/uploadMasterData`, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    })
      .then(async (res) => {
        await dispatch(setResponse());
        await dispatch(setMasterResponse("File Uploaded Successfully.!"));
        await dispatch(setDataSuccess());
        await dispatch(getCourseMasterData())
      })
      .catch((err) => {
        console.error("error is", err);
        dispatch(
          setMasterResponse(
            err.response.data.error || '"Failed to upload file!"'
          )
        );
        dispatch(setDataFailure());
      });
  };
}
export function getTrainingListMonthWise(month, year) {
  return (dispatch) => {
    dispatch(setLoaded());
    Axios.get(`${baseURL}/fetchmonthlist`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
      params: {
        month,
        year,
      },
    })
      .then((res) => {
        res.data.map((val, i) => {
          val.sno = i + 1;
        });
        dispatch(setMonthWiseTrainingList(res.data));
        dispatch(setDataSuccess())
      })
      .catch((err) => {
        dispatch(setError(err));
      });
  };
}

export function getNominatedCourseListTH() {
  return (dispatch) => {
    Axios.get(`${baseURL}/getnominatedcourselistTH`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })

      .then((res) => {
        // res.data.map((val, i) => {
        //   val.sno = i + 1;
        // });
        dispatch(setNominatedCourseListTH(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}
export function getNominatedUserListTH(code, date) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/getnominateduserlist/${code}`,
      { date },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )

      .then((res) => {
        res.data.map((val, i) => {
          val.sno = i + 1;
        });
        dispatch(setNominatedUserListTH(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}
export function downloadRangeNominatedUserListTH(data) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/downloadrangenominateduserlist`,
      { data },
      {
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        fileDownload(res.data, `Nomination List.xlsx`);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function getAllNominationDataTH(courseCode, sessionCode, filter) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/getfiltereddataTH`,
      { courseCode, sessionCode, filter },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        res.data.map((val, i) => {
        val.sno = i + 1;
        });
        dispatch(setFilteredListTH(res.data));
        dispatch(getCount(sessionCode))
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
// export function changeRejectStatusDataTH(
//   id,
//   date,
//   status,
//   code,
//   filter,
//   actionReason
// ) {
//   return (dispatch) => {
//     Axios.post(
//       `${baseURL}/changerejectedstatus`,
//       { id, date, status, actionReason },
//       {
//         headers: {
//           Authorization: localStorage.getItem("token"),
//           "Content-Type": "application/json",
//         },
//       }
//     )
//       .then((res) => {
//         dispatch(setDataSuccess());
//         dispatch(getCount(code, date));
//         dispatch(getNominatedCount(code, date));
//         dispatch(getAllNominationDataTH(code, date, filter));
//       })
//       .catch((err) => {
//         dispatch(setError(err));

//         console.error("error is", err);
//       });
//   };
// }
export function downloadSessionWiseNominatedList(sessionCode, courseCode, startDate, filter) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/downloadNominationList`,
      { sessionCode, courseCode, startDate, filter },
      {
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        fileDownload(res.data, `Nomination List.xlsx`);
      })
      .catch((err) => {
        console.error("error is", err);
      });
  };
}
export function closeAlert() {
  return (dispatch) => {
    dispatch(setAlert());
  };
}

export function uploadAbacusFile(file, username) {
  return (dispatch) => {
    dispatch(setLoaded());
    return Axios.post(`${baseURL}/uploadAbacusData/${username}`, file, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then((res) => {
        dispatch(setAbacusResponse("File Uploaded Successfully.!"));
        dispatch(setDataSuccess());
      })
      .catch((err) => {
        dispatch(
          setAbacusResponse(
            err.response.data.error || "Sorry!!! Failed to upload"
          )
        );
        dispatch(setDataFailure());
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}

export function getCount(sessionCode) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/getcount`,
      { sessionCode},
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setCount(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}

export function getNominatedCount(course, date) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/getnominatedcount`,
      { course, date },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setNominatedCount(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}
export function finaliseBatch(id, date) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/finalisebatch`,
      { id, date },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        //  dispatch(setNominatedCount(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));

        console.error("error is", err);
      });
  };
}

export function THSettings(track, bypassApprover, bypassAbacus) {
  return (dispatch) => {
    Axios.post(
      `${baseURL}/tracks`,
      { track, bypassApprover, bypassAbacus },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        //  dispatch(setBypassApprover())
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
}




///////////////////////////SESSIONS SLICES//////////////////////////
////////////////////////////////////////////////////////////////////


export function getCurrentMonth() {
 return (dispatch) => {
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth() + 1;
  dispatch(setCurrentMonthIndex(currentMonthIndex));
 };
}







///////////////////////////Nomination SLICES//////////////////////////
////////////////////////////////////////////////////////////////////

export function updateLoginUserName(name) {
 return (dispatch) => {
  dispatch(setEnterpriseID({ name }));
 };
}
export function fetchMyNominations(username,startDate,endDate) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchMyNominations`,
   { username,startDate,endDate },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    dispatch(setMyNominationData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}


export function getTrainingListData(month, year) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchTrainingList/${month}/${year}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setTrainingData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}

export function uploadNominations (formData, userEnterpriseID) {
    return (dispatch) => {
    dispatch(setLoaded())
        return Axios.post(
              `${baseURL}/uploadnominationfile/${userEnterpriseID}`,
              formData,
              {
                  headers: {
                      Authorization: localStorage.getItem("token"),
                      'Content-Type': 'multipart/form-data',
                  },
              },
          ).then((response) => {
             dispatch(setDataSuccess());
             return response;
        })
        .catch((err) => {
                dispatch(setDataFailure());
                console.error("error is", err);
                throw err;
        })
}
}


export const fetchTHAdminUser = (trackId) => {
  return (dispatch) => {
    Axios.get(`${baseURL}/thAdminUser/${trackId}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        console.log('resss----', res.data)
        dispatch(setTrackAdminUsers(res.data))
      })
      .catch((err) => {
        // dispatch(setError(err));
        console.error("error is", err);
      });
  };
};